import {
  AssistantTrigger,
  type AssistantTriggerProps,
} from "#src/components/Assistant/AssistantTrigger";
import { useAssistant } from "#src/contexts/Assistant";
import {
  colours,
  Icon,
  Link,
  type DataDisplayProps,
} from "@validereinc/common-components";
import React from "react";

export type AssistantUserDataDisplayProps = AssistantTriggerProps &
  Pick<DataDisplayProps, "isLoading" | "isBusy" | "isInline" | "alignment"> & {
    sizeVariant?: "small" | "medium";
  };

export const AssistantUserDataDisplay = ({
  sizeVariant = "medium",
  alignment = "left",
  isInline,
  isLoading,
  isBusy,
  onClick,
}: AssistantUserDataDisplayProps) => {
  const setIsOpen = useAssistant((s) => s.setIsOpen);

  const handleClick: AssistantUserDataDisplayProps["onClick"] = (evt) => {
    setIsOpen(true);
    onClick?.(evt);
  };

  return (
    <div
      aria-label="Assistant user details"
      style={{
        display: isInline ? "inline-flex" : "flex",
        alignItems: isInline ? "baseline" : "center",
        justifyContent:
          alignment === "justified"
            ? "center"
            : alignment === "right"
              ? "flex-end"
              : "flex-start",
      }}
    >
      {isInline ? (
        <Icon
          variant="sparkle"
          colour={colours.colours.teal[800]}
          weight="fill"
          size={sizeVariant === "medium" ? 12 : 8}
          style={{ marginRight: 4 }}
        />
      ) : (
        <AssistantTrigger
          isLoading={isLoading}
          isBusy={isBusy}
          variant="special"
          style={{
            borderRadius: "50%",
            marginRight: 8,
          }}
          iconProps={
            sizeVariant === "medium"
              ? {
                  size: 18,
                }
              : {
                  size: 12,
                }
          }
          {...(onClick ? { onClick: handleClick } : {})}
        />
      )}
      {onClick ? (
        <Link
          label="Validere Assistant"
          onClick={handleClick}
          anchorTagProps={{
            style:
              sizeVariant === "medium"
                ? {
                    fontSize: "inherit",
                  }
                : {
                    fontSize: "12px",
                  },
          }}
        />
      ) : (
        "Validere Assistant"
      )}
    </div>
  );
};
